import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import history from 'store/history';

import App from 'layouts/App';

import { HomePage } from './Home';
import { ConceptPage } from './Concept';
import { ThemePage } from './Theme';
import { SectionPage } from './Section';
import { BoothPage } from './Booth';
import { AboutPage } from './About';

const Routes = () => (
	<Router history={history}>
		<App>
			<Switch>
				<Route exact path="/concept" component={ConceptPage} />
				<Route exact path="/theme" component={ThemePage} />
				<Route exact path="/theme/:id" component={SectionPage} />
				<Route exact path="/theme/:id/:id" component={BoothPage} />
				<Route exact path="/about" component={AboutPage} />
				<Route exact path="/" component={HomePage} />
			</Switch>
		</App>
	</Router>
);

export default Routes;
